import React, { useState, useEffect } from 'react';
import { ConfigContext } from './ConfigContext';
import ErrorComponent from "../components/Error";
import Loader from "../images/loader.gif";

const CONFIG_SOURCE_URL = `${process.env.REACT_APP_BFF_URL}/config`;

export function ConfigProvider({ children }) {
    const [config, setConfig] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchConfig = async () => {
            try {
                setLoading(true);
                setError(null); // Reset error on refetch/retry attempt
                //console.log(`Fetching configuration from: ${CONFIG_SOURCE_URL}`);

                const response = await fetch(CONFIG_SOURCE_URL);

                if (!response.ok) {
                    throw new Error(`Failed to fetch config: ${response.status} ${response.statusText}`);
                }

                const data = await response.json();

                if (!data) {
                    throw new Error("Configuration data is empty or invalid.");
                }

                setConfig(data);
                //console.log("Configuration loaded successfully:", data);

            } catch (err) {
                //console.error("Configuration loading failed:", err);
                setError(err.message || "An unknown error occurred while loading configuration.");
                setConfig(null); // Ensure config is null on error
            } finally {
                setLoading(false);
            }
        };

        fetchConfig();
    }, []); // Empty dependency array ensures this runs only once on mount

    // Render loading state
    if (loading) {
        return (
            <div
                style={{
                    display: "flex",
                    height: "100vh",
                    width: "100vw",
                    alignContent: "center",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <img
                    src={Loader}
                    alt='(Chargement...)'
                    style={{
                        width: "230px",
                        minWidth: "100px",
                    }}
                />
            </div>
        );
    }

    // Render error state
    if (error) {
        return <ErrorComponent />;
    }

    // Render children only when config is successfully loaded
    // The `ConfigContext.Provider` makes the `config` object available
    // to all descendant components using the `useConfig` hook.
    return (
        <ConfigContext.Provider value={config}>
            {children}
        </ConfigContext.Provider>
    );
}